// Module
var code = "<div class=\"vui-more-action\" tabindex=\"{{$id}}\" ng-transclude></div>\n";
// Exports
module.exports = code;